<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="dialogTitle"
    width="35%"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item label="项目名称" prop="projectName">
        <el-input
          v-model="formData.projectName"
          placeholder="请输入"
          style="width: 300px"
          maxlength="50"
          :disabled="formType == 'view'"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目时间" prop="projectDate">
        <el-date-picker
          v-model="formData.projectDate"
          type="date"
          placeholder="选择日期"
          :disabled="formType == 'view'"
          style="width: 300px"
        />
      </el-form-item>

      <el-form-item label="下单金额" :span="8" prop="projectAmount">
        <el-input-number
          v-model="formData.projectAmount"
          placeholder="请输入"
          clearable
          :min="0"
          :max="99999999"
          controls-position="right"
          :precision="2"
          style="width: 300px"
          :disabled="formType == 'view'"
        >
        </el-input-number>
        <span class="marginLeft10">元</span>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="flex" style="justify-content: center">
        <el-button
          :disabled="formLoading"
          type="primary"
          @click="submitForm"
          v-if="formType != 'view'"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">
          {{ formType == "view" ? "关 闭" : "取 消" }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { Message } from "element-ui";
import {
  factoryManageProjectAdd,
  factoryManageProjectUpdate,
} from "@/api/factory/projectInfo";

import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";
export default {
  name: "index",
  components: {},
  props: {
    classifyList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      formData: {
        projectName: "",
        projectDate: "",
        projectAmount: null,
      },
      formRules: {
        projectName: [{ required: true, message: "请输入", trigger: "blur" }],
        projectAmount: [{ required: true, message: "请输入", trigger: "blur" }],
        projectDate: [{ required: true, message: "请选择", trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    /** 打开弹窗 */
    async open(type, row) {
      this.resetForm();
      this.dialogTitle =
        type === "view" ? "详情" : type === "create" ? "新增项目" : "编辑项目";
      this.formType = type;
      // 修改时，设置数据
      if (row && row.id) {
        this.formLoading = true;
        try {
          this.formData = {
            ...row,
          };
        } finally {
          this.formLoading = false;
        }
      }
      this.dialogVisible = true;
    },
    async submitForm() {
      // 校验表单
      if (!this.$refs.formRef) return;
      const valid = await this.$refs.formRef.validate();
      if (!valid) return;
      try {
        const newData = {
          ...this.formData,
          projectDate: dayjs(this.formData.projectDate).format("YYYY-MM-DD"),
        };

        this.formLoading = true;
        if (this.formType === "create") {
          console.log(this.$route.query.id, "111222333");
          const res = await factoryManageProjectAdd({
            ...newData,
            factoryId: this.$route.query.id,
          });
          if (res.code == 200) {
            Message.success("新增成功");
          }
        } else {
          const res = await factoryManageProjectUpdate(newData);
          if (res.code == 200) {
            Message.success("修改成功");
          }
        }
        this.dialogVisible = false;
        // 发送操作成功的事件
        this.$emit("success");
        this.formLoading = false;
      } catch (e) {
        this.$message.error(e);
        this.formLoading = false;
      } finally {
      }
    },

    // 重置
    resetForm() {
      this.formData = {
        projectName: "",
        projectDate: "",
        projectAmount: null,
      };
    },
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
  },
};
</script>
<style scoped >
.video_box {
  margin-left: 3%;
  margin-bottom: 10px;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
}
/deep/.el-input__inner {
  text-align: left;
}
.details_box {
  margin-right: 10%;
  max-width: 100%;
  overflow: hidden;
}
</style>
